import { useState, useCallback } from 'react';
import { Box, Typography } from '@material-ui/core';

import { useRouteMatch, useHistory, useParams } from 'react-router-dom';
import PlaceDetails from '../components/PlaceDetails/PlaceDetails';
import {Scrollbar} from 'smooth-scrollbar-react';

import { translations } from '../i18n/i18n';
import MapLegendComponent from '../components/Map/MapLegend.component';
import MapFilterComponent from '../components/Map/MapFilter.component';
import MapComponent from '../components/Map/Map.component';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
	info: {
		margin: theme.spacing(0, 2, 0, 2),

		'@media (min-height: 1000px)': {
			marginBottom: theme.spacing(2),
		},
	}
}));

function HomePage({ data, onInitialized }) {
	const [placesToShow, setPlacesToShow] = useState(data.places);
	const [currentLayer, setCurrentLayer] = useState('DARE');
	const { path, url } = useRouteMatch();
	const history = useHistory();
	const { placeId } = useParams();
	const classes = useStyles();

	const notifyAboutCurrentLayer = useCallback((layer) => {
		if(currentLayer != layer) {
			setCurrentLayer(layer);
		}
	}, [currentLayer]);
	
	const closePlaceDetails = useCallback(() => history.push(path.replace(':placeId?', '')), [history, path]);

	return (
		<div className="map-page">
			<MapComponent placeTypes={data.place_types} onInitialized={onInitialized} placesToShow={placesToShow} notifyAboutCurrentLayer={notifyAboutCurrentLayer} />

			<div className="filters-container">
				<Scrollbar>
					<div className={classes.info}>
						<Typography color="secondary" variant="h6" align="center" gutterBottom>{data.settings[`sidebar_title_${translations.getLanguage()}`]}</Typography>
						<Typography align="justify" variant="body2" className="text-minor">{data.settings[`sidebar_text_${translations.getLanguage()}`]}</Typography>
					</div>

					<MapFilterComponent placeTypes={data.place_types} places={data.places} setPlacesToShow={setPlacesToShow} />

					<MapLegendComponent placeTypes={data.place_types} currentLayer={currentLayer} />
				</Scrollbar>
			</div>

			<PlaceDetails placeId={placeId} placeTypes={data.place_types} photoTypes={data.photo_types} modelTypes={data.model_types} onCloseRequest={closePlaceDetails} />
		</div>
	);
}
  
export default HomePage;  